import { useMemo } from 'react';

import { useGetCustomerCurrentUser } from 'api';

import type { MfaSettings } from './useFetchMfaSettings';

export function useMfaSettings(): MfaSettings {
  const { data: currentUser, isLoading: userLoading } =
    useGetCustomerCurrentUser();

  const user = currentUser?.user;

  const totpEnabled = useMemo(() => user?.has_verify_setup ?? false, [user]);

  return {
    totpEnabled,
    loading: userLoading,
    hasVerifySetup: Boolean(user?.has_verify_setup),
    skipMfa: Boolean(user?.skip_mfa),
    hasPhone: Boolean(user?.has_phone)
  };
}
